import { TelemetryConfiguration } from './TelemetryInterface';
import { appConfiguration } from '../../environments/app.config';

/**
 * Telemetry configuration derived from the environment app config.
 *
 * `features.enableTelemetry` acts as a kill switch: when false the telemetry client is
 * constructed but sends nothing, so no call site needs to branch on it.
 */
export const TelemetryConfig: TelemetryConfiguration = {
    environmentValue: appConfiguration.telemetry.environmentValue,
    configuration: {
        connectionString: appConfiguration.telemetry.connectionString,
        loggingLevelTelemetry: appConfiguration.telemetry.loggingLevelTelemetry,
        loggingLevelConsole: appConfiguration.telemetry.loggingLevelConsole,
    },
    environmentName: appConfiguration.environment,
    version: appConfiguration.version,
    enabled: appConfiguration.features.enableTelemetry,
    correlationHeaderDomains: appConfiguration.telemetry.correlationHeaderDomains ?? [],
};